import { createPathFromRoute } from 'assets/utils/dom/UrlParsing';
import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.Contract.SetRefundedStatus.IRequest;
type Response = Api.Core.Contract.SetRefundedStatus.IResponse;
type Headers = Api.Core.Contract.SetRefundedStatus.IHeaders;
const url = '/api/Sales/Contract/SetRefundedStatus/:contractId';
export default async function contractSetRefundedStatusApi({ contractId }: Request): Promise<Api.Res<Response>> {
  const serverResponse = await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.put,
    url: createPathFromRoute(url, { contractId }),
    headers: getDefaultHeaders(),
  });
  return serverResponse;
}
